import React from "react";

const HistoricalTable = ({ rows = [] }) => {
  return (
    <table className="table historical-table">
      <thead>
        <tr>
          <th className="historical-table-header" scope="col">
            Date
          </th>
          <th className="historical-table-header" scope="col">
            Entry Price
          </th>
          <th className="historical-table-header" scope="col">
            Exit Price
          </th>
        </tr>
      </thead>

      <tbody>
        {rows.length > 0 ? (
          rows.map((row) => (
            <tr key={row.id}>
              <td className="historical-date-column">{row.date}</td>
              <td className="historical-other-column">{row.entryPrice}</td>
              <td className="historical-other-column">{row.exitPrice}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3">No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default HistoricalTable;